module.exports = __webpack_public_path__ + "static/media/check_circle_black_24dp.538b65eb.svg";